import React, { useEffect, useState } from "react";
import "./offer.css";
import web from "../../assets/website-developement.jpg";
import PopupForm from "../popupform/PopupForm";
import AOS from "aos";
import "aos/dist/aos.css";

function Offer() {
     const [open, setOpen] = useState(false);

     
    useEffect(() => {
        AOS.init({
            duration: 800,
            easing: "ease-in-out",
            once: true,
        });
    }, []);
    return (
        <>
            <section className="offer-section"  data-aos="fade-up">
                <h1 className="offer-heading">WHAT WE <span style={{ color: "#ffdd00"}}>OFFER! </span></h1>
            </section>

            {/* Header Section */}
                <section data-aos="fade-up" data-aos-delay="100">
                <div className="container1">
                    <div className="centered">WEBSITE DEVELOPMENT</div>
                </div>
            </section>

            {/* Pricing Section */}
            <section className="pricing-section">
                <div className="pricing-container">

                    {/* BASIC PLAN */}
                    <div className="price-card " data-aos="fade-right" data-aos-delay="200">
                        <h3 className="plan-title basic">Basic Plan</h3>
                        <h2 className="plan-price">₹9999</h2>
                        <p className="one-time">One Time</p>

                        <ul className="features">
                            <li>5 Pages Website</li>
                            <li>1 Year Free Domain Name</li>
                            <li>1 Year Free Hosting</li>
                            <li>Admin Panel Access</li>
                            <li>Lifetime Free SSL Certificate</li>
                            <li>Speed Optimization</li>
                            <li>Social Media Integration</li>
                            <li>WhatsApp Button Integration</li>
                            <li>Contact Form</li>
                            <li>Call Button Integration</li>
                            <li>1 Year Technical Support</li>
                            <li>Annual Renewal (Hosting) ₹3000</li>
                        </ul>

                        <button className="plan-btn"   onClick={() => setOpen(true)}>Get This Plan</button>
                    </div>

                    {/* STANDARD PLAN */}
                    <div className="price-card popular" data-aos="fade-up" data-aos-delay="300">
                        <div className="ribbon">Popular</div>
                        <h3 className="plan-title standard">Standard Plan</h3>
                        <h2 className="plan-price">₹20000</h2>
                        <p className="one-time">One Time</p>

                        <ul className="features">
                            <li>10 Pages Website</li>
                            <li>1 Year Free Domain Name</li>
                            <li>1 Year Free Hosting</li>
                            <li>Admin Panel Access</li>
                            <li>Personalized Training</li>
                            <li>Free SSL Certificate</li>
                            <li>Speed Optimization</li>
                            <li>Social Media Integration</li>
                            <li>WhatsApp Button Integration</li>
                            <li>Contact Form</li>
                            <li>Call Button Integration</li>
                            <li>1 Year Technical Support</li>
                        </ul>

                        <button className="plan-btn"   onClick={() => setOpen(true)}>Get This Plan</button>
                    </div>

                    {/* PREMIUM PLAN */}
                    <div className="price-card" data-aos="fade-left" data-aos-delay="400">
                        <h3 className="plan-title premium">Premium Plan</h3>
                        <h2 className="plan-price">₹35000</h2>
                        <p className="one-time">One Time</p>

                        <ul className="features">
                            <li>Unlimited Pages Website</li>
                            <li>1 Year Free Domain Name</li>
                            <li>1 Year Free Hosting</li>
                            <li>Admin Panel Access</li>
                            <li>Personalized Training</li>
                            <li>Advanced Security Suite</li>
                            <li>Speed Optimization</li>
                            <li>Social Media Integration</li>
                            <li>WhatsApp Button Integration</li>
                            <li>Contact Form</li>
                            <li>Call Button Integration</li>
                            <li>1 Year Technical Support</li>
                        </ul>

                        <button className="plan-btn"   onClick={() => setOpen(true)}>Get This Plan</button>
                    </div>

                    {/* CUSTOM PLAN */}
                    <div className="price-card" data-aos="fade-down" data-aos-delay="500">
                        <h3 className="plan-title custom">Custom Plan</h3>
                        <h2 className="plan-price">???</h2>
                        <p className="one-time">May Vary</p>

                        <ul className="features">
                            <li>Pages According to Requirement</li>
                            <li>1 Year Free Domain Name</li>
                            <li>1 Year Free Hosting</li>
                            <li>Admin Panel Access</li>
                            <li>Custom Features</li>
                            <li>Free SSL Certificate</li>
                            <li>Speed Optimization</li>
                            <li>WhatsApp Button Integration</li>
                            <li>Contact Form</li>
                            <li>Call Button Integration</li>
                            <li>1 Year Technical Support</li>
                        </ul>

                        <button className="plan-btn"   onClick={() => setOpen(true)}>Get This Plan</button>
                    </div>

                </div>
            </section>
            <section>
                <div className="container1" data-aos="fade-up">
                  
                    <div className="centered">LOGO DESIGN</div>
                </div>
            </section>

            <section className="pricing-section">
                <div className="pricing-container">

                    {/* BASIC PLAN */}
                    <div className="price-card" data-aos="fade-right" data-aos-delay="200">
                        <h3 className="plan-title basic">Basic Plan</h3>
                        <h2 className="plan-price">₹1000</h2>
                        <p className="one-time">One Time</p>

                        <ul className="features">
                            <li>2-3 initial concepts</li>
                            <li>2 revisions</li>
                            <li>File formats: JPEG, PNG</li>
                            <li>Turnaround: 2-3 days</li>

                        </ul>

                        <button className="plan-btn"   onClick={() => setOpen(true)}>Get This Plan</button>
                    </div>

                    {/* STANDARD PLAN */}
                    <div className="price-card popular" data-aos="fade-up" data-aos-delay="300">
                        <div className="ribbon">Popular</div>
                        <h3 className="plan-title standard">Standard Plan</h3>
                        <h2 className="plan-price">₹3000</h2>
                        <p className="one-time">One Time</p>

                        <ul className="features">
                            <li>4-5 initial concepts</li>
                            <li>3-5 revisions </li>
                            <li>File formats: JPEG, PNG, SVG, PDF
                            </li>
                            <li>Black-and-white version
                            </li>
                            <li>Turnaround: 4-6 days
                            </li>

                        </ul>

                        <button className="plan-btn"   onClick={() => setOpen(true)}>Get This Plan</button>
                    </div>

                    {/* PREMIUM PLAN */}
                    <div className="price-card" data-aos="fade-left" data-aos-delay="400">
                        <h3 className="plan-title premium">Premium Plan</h3>
                        <h2 className="plan-price">₹5000</h2>
                        <p className="one-time">One Time</p>

                        <ul className="features">
                            <li>6-8 initial concepts</li>
                            <li>Unlimited revisions
                            </li>
                            <li>File formats: JPEG, PNG, SVG, PDF, AI
                            </li>
                            <li>Brand guidelines (font, color palette)
                            </li>
                            <li>Mockups for stationery, social media
                            </li>
                            <li>Turnaround: 7-10 days
                            </li>


                        </ul>

                        <button className="plan-btn"   onClick={() => setOpen(true)}>Get This Plan</button>
                    </div>

                    {/* CUSTOM PLAN */}
                    <div className="price-card" data-aos="fade-down" data-aos-delay="500">
                        <h3 className="plan-title custom">Custom Plan</h3>
                        <h2 className="plan-price">₹5000</h2>
                        <p className="one-time">May Vary</p>

                        <ul className="features">
                            <li>Fully customized concepts</li>
                            <li>Multiple presentations</li>
                            <li>Collaboration with branding team</li>
                            <li>Advanced mockups (billboards, products)</li>
                            <li>Editable files: AI, PSD</li>
                            <li>Turnaround: Based on project scope</li>
                        </ul>

                        <button className="plan-btn"   onClick={() => setOpen(true)}>Get This Plan</button>
                    </div>

                </div>
            </section >

            <section>
                <div className="container1" data-aos="fade-up" >
                   
                    <div className="centered">DIGITAL MARKETING</div>
                </div>
            </section>

            <section className="pricing-section">
                <div className="pricing-container">

                    {/* BASIC PLAN */}
                    <div className="price-card" data-aos="fade-right" data-aos-delay="200">
                        <h3 className="plan-title basic">Basic Plan</h3>
                        {/* <h2 className="plan-price">₹1000</h2>
                        <p className="one-time">One Time</p> */}

                        <ul className="features">
                            <li><strong>Search Engine Optimization (SEO): </strong> Keyword research & basic on-page optimization.
                            </li>
                            <li><strong>Pay-Per-Click Advertising (PPC):</strong>  Google Ads campaign setup & basic management.
                            </li>
                            <li><strong>Social Media Management: </strong>Management of up to 2 platforms (e.g., Facebook, Instagram).</li>
                            <li><strong>Content Marketing:</strong> 2 blog posts/month + content updates.</li>

                        </ul>

                        <button className="plan-btn"   onClick={() => setOpen(true)}>Get This Plan</button>
                    </div>

                    {/* STANDARD PLAN */}
                    <div className="price-card popular" data-aos="fade-up" data-aos-delay="300">
                        <div className="ribbon">Popular</div>
                        <h3 className="plan-title standard">Standard Plan</h3>
                        {/* <h2 className="plan-price">₹3000</h2>
                        <p className="one-time">One Time</p> */}

                        <ul className="features">
                            <li>   <strong> Search Engine Optimization (SEO): </strong>                        On-page SEO, link building, and monthly reporting.
                            </li>
                            <li><strong>Pay-Per-Click Advertising (PPC):</strong> Google Ads + Bing Ads, campaign optimization.
                            </li>
                            <li><strong>Social Media Management:</strong> Management of up to 4 platforms + content creation.

                            </li>
                            <li><strong>Content Marketing:</strong> 4 blog posts/month, content strategy.
                            </li>
                          


                        </ul>

                        <button className="plan-btn"   onClick={() => setOpen(true)}>Get This Plan</button>
                    </div>

                    {/* PREMIUM PLAN */}
                    <div className="price-card" data-aos="fade-left" data-aos-delay="400">
                        <h3 className="plan-title premium">Premium Plan</h3>
                        {/* <h2 className="plan-price">₹5000</h2>
                        <p className="one-time">One Time</p> */}

                        <ul className="features">
                            <li>   <strong> Search Engine Optimization (SEO): </strong> 
Comprehensive SEO audit, on-page & off-page SEO, advanced analytics, and competitor analysis.
                            </li>
                            <li><strong>Pay-Per-Click Advertising (PPC):</strong>  Full PPC strategy, multi-platform (Google, Bing, social ads), A/B testing, and ongoing optimization.
                            </li>
                            <li><strong>Social Media Management:</strong> Full social media strategy across 5+ platforms, including paid ads, influencer outreach, and engagement.

                            </li>
                            <li><strong>Content Marketing:</strong>8+ blog posts/month, multimedia content, email newsletters.
                            </li>

                        </ul>

                        <button className="plan-btn"   onClick={() => setOpen(true)}   onClick={() => setOpen(true)}>Get This Plan</button>
                    </div>

                    {/* CUSTOM PLAN */}
                    
                </div>
            </section >

             {open && <PopupForm close={() => setOpen(false)} />}
        </>
    );
}

export default Offer;
